import {Component, ViewEncapsulation, inject} from '@angular/core';
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {RouterService} from "../../../shared/services/router.service";
import {IconBarPolicy, IconBarService} from "../../../shared/services/icon-bar.service";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {NavService} from "../../../shared/services/nav.service";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ToasterService} from "../../../shared/services/toaster.service";
import {LanguageService} from "../../../shared/services/language.service";

@Component({
    selector: 'app-bar-icons',
    imports: [
        FormButtonComponent,
        TooltipComponent,
        TranslatePipe
    ],
    templateUrl: './bar-icons.component.html',
    styleUrl: './bar-icons.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BarIconsComponent {
  public routerService: RouterService = inject(RouterService);
  private barIconService: IconBarService = inject(IconBarService);
  private toasterService: ToasterService = inject(ToasterService);
  private languageService: LanguageService = inject(LanguageService);
  public navService: NavService = inject(NavService);

  public iconBarVisible: boolean = false;
  public iconBarPolicy: IconBarPolicy = IconBarPolicy.Toggleable;

  public constructor() {
    this.barIconService.iconBarVisible
    .pipe(takeUntilDestroyed())
    .subscribe((value) => {
      this.iconBarVisible = value;
    });

    this.barIconService.iconBarPolicy
    .pipe(takeUntilDestroyed())
    .subscribe((value) => {
      this.iconBarPolicy = value;
    });
  }

  public get shouldShowIconBar(): boolean {
    return this.iconBarPolicy === IconBarPolicy.ForcedVisible || this.iconBarVisible;
  }

  public handleNavigation(targetRoute: string, navigationLabel: string): void {
    const normalizedTargetRoute = this.normalizeRoute(targetRoute);
    const normalizedCurrentRoute = this.normalizeRoute(this.routerService.getCurrentUrl());

    if (normalizedCurrentRoute === normalizedTargetRoute) {
      this.toasterService.warning(
        navigationLabel,
        this.languageService.getTranslationByKey('ALREADYONTHISPAGE')
      );
      return;
    }

    this.routerService.navigateTo(targetRoute);
  }

  private normalizeRoute(route: string): string {
    const trimmedRoute = route.trim();
    if (!trimmedRoute) {
      return '';
    }

    if (/^https?:\/\//i.test(trimmedRoute)) {
      try {
        const parsedUrl = new URL(trimmedRoute);
        if (parsedUrl.origin === window.location.origin) {
          return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        }
      } catch {
        return trimmedRoute;
      }
    }

    const normalizedRoute = trimmedRoute.startsWith('/') ? trimmedRoute : `/${trimmedRoute}`;

    return normalizedRoute !== '/' && normalizedRoute.endsWith('/')
      ? normalizedRoute.slice(0, -1)
      : normalizedRoute;
  }
}
